import { environment } from 'src/environments/environment';
import { UserRole } from '@common/enums/user-roles.enum';
const adminRoot = environment.adminRoot;

export interface IMenuItem {
  id?: string;
  icon?: string;
  label: string;
  to: string;
  newWindow?: boolean;
  subs?: IMenuItem[];
  roles?: UserRole[];
  iconClass?: string;
  textClass?: string;
}

const data: IMenuItem[] = [
  {
    icon: 'iconsminds-monitor-analytics',
    label: 'Dashboard',
    to: `${adminRoot}/dashboards/default`,
  },
  {
    icon: 'iconsminds-shopping-cart',
    label: 'Orders',
    to: `${adminRoot}/orders`,
  },
  {
    icon: 'iconsminds-cash-register-2',
    label: 'Payments',
    to: `${adminRoot}/payments`,
  },
  {
    icon: 'iconsminds-cash-register-2',
    label: 'Return',
    to: `${adminRoot}/sale-return`,
  },
  {
    icon: 'simple-icon-docs',
    label: 'Reports',
    to: `${adminRoot}/reports`,
  },
  {
    icon: 'simple-icon-settings',
    label: 'Setup',
    to: `${adminRoot}`,
    subs: [
      {
        label: 'Integration',
        to: '/Integration',
        textClass: 'icon-custom-danger',
        subs: [
          {
            icon: 'iconsminds-sharethis',
            label: 'Selling Channels',
            to: `${adminRoot}/Setup/selling-channel-list`,
            iconClass: 'icon-custom-danger'
          },
          {
            icon: 'iconsminds-ship',
            label: 'Shipping Carriers',
            to: `${adminRoot}/Setup/shipping-carrier-list`,
            iconClass: 'icon-custom-danger'
          },
          {
            icon: 'iconsminds-map-marker-2',
            label: 'Destinations',
            to: `${adminRoot}/Setup/destination-carrier-list`,
            iconClass: 'icon-custom-danger'
          },
          {
            icon: 'iconsminds-data-download',
            label: 'Import Data',
            to: `${adminRoot}/Setup/import`,
            iconClass: 'icon-custom-danger'
          },
          {
            icon: 'iconsminds-speach-bubbles',
            label: 'Message Providers',
            to: `${adminRoot}/Setup/company-sms-service-providers-list`,
            iconClass: 'icon-custom-danger'
          },
        ],
      },
      {
        label: 'Security',
        to: '/user',
        textClass: 'icon-custom-success',
        subs: [
          {
            icon: 'iconsminds-security-settings',
            label: 'Users',
            to: `${adminRoot}/Setup/user-management`,
            iconClass: 'icon-custom-success'
          },
          {
            icon: 'iconsminds-gears',
            label: 'Roles',
            to: `${adminRoot}/Setup/roles-list`,
            iconClass: 'icon-custom-success'
          },
        ]
      },
      {
        id: 'sub-setup',
        label: 'Setup',
        to: '/Setup',
        textClass: 'icon-custom-info',
        subs: [
          {
            icon: 'iconsminds-shopping-cart',
            label: 'Products',
            to: `${adminRoot}/Setup/products`,
            iconClass: 'icon-custom-info'
          },
          {
            icon: 'iconsminds-shopping-cart',
            label: 'Product Options',
            to: `${adminRoot}/Setup/productOptions`,
            iconClass: 'icon-custom-info'
          },
          {
            icon: 'iconsminds-add-user',
            label: 'Customers',
            to: `/app/Setup/customer`,
            iconClass: 'icon-custom-info'
          },
          {
            icon: 'iconsminds-gear',
            label: 'Company Settings',
            to: `${adminRoot}/Setup/company-setting`,
            iconClass: 'icon-custom-info'
          },
          {
            icon: 'iconsminds-tag-3',
            label: 'Reasons & Tags',
            to: `${adminRoot}/Setup/reason-tag`,
            iconClass: 'icon-custom-info'
          },
          {
            icon: 'iconsminds-gears',
            label: 'Status Management',
            to: `${adminRoot}/Setup/status-management`,
            iconClass: 'icon-custom-info'
          }, 
          {
            icon: 'iconsminds-formspring',
            label: 'Message Format',
            to: `${adminRoot}/Setup/message-format`,
            iconClass:'icon-custom-info'
          },
          {
            icon: 'iconsminds-email',
            label: 'Email Template',
            to: `${adminRoot}/Setup/email-template`,
            iconClass: 'icon-custom-info'
          },
          {
            icon: 'iconsminds-building',
            label: 'Warehouses',
            to: `/app/Setup/warehouse`,
            iconClass: 'icon-custom-info'
          },
          {
            icon: 'iconsminds-tennis-ball',
            label: 'Countries',
            to: `/app/Setup/country`,
            iconClass: 'icon-custom-info'
          },
          {
            icon: 'iconsminds-the-white-house',
            label: 'Cities',
            to: `/app/Setup/city`,
            iconClass: 'icon-custom-info'
          },
          {
            icon: 'iconsminds-check',
            label: 'Task Monitor',
            to: `/app/Setup/task-monitor`,
            iconClass: 'icon-custom-info'
          },
        ],
      },
      {
        label: 'Administration',
        to: '/Administration',
        textClass: 'icon-custom-purple',
        subs: [
          {
            icon: 'iconsminds-formspring',
            label: 'SMS Service Providers',
            to: `${adminRoot}/Setup/sms-service-providers-list`,
            iconClass: 'icon-custom-purple'
          },
          {
            icon: 'iconsminds-add-user',
            label: 'Manage Page Action',
            to: `${adminRoot}/Setup/manage-action-groups`,
            iconClass: 'icon-custom-purple'
          },
          {
            icon: 'iconsminds-check',
            label: 'Task Monitor',
            to: `${adminRoot}/Setup/task-monitor`,
            iconClass: 'icon-custom-purple'
          },
          {
            icon: 'iconsminds-box-with-folders',
            label: 'Companies Overview',
            to: `${adminRoot}/Setup/companies-overview`,
            iconClass:'icon-custom-purple'
          },
          {
            icon: 'iconsminds-server-2',
            label: 'Prospect Report',
            to: `${adminRoot}/Setup/prospect-report`,
            iconClass: 'icon-custom-purple'
          },
          {
            icon: 'iconsminds-tag-3',
            label: 'Subscription Promos',
            to: `${adminRoot}/subscription/promo-list`,
            iconClass: 'icon-custom-purple'
          },
          {
            icon: 'iconsminds-tag-3',
            label: 'Subscription Plans',
            to: `${adminRoot}/subscription/plan-list`,
            iconClass: 'icon-custom-purple'
          },
          {
            icon: 'iconsminds-security-settings',
            label: 'Verify License',
            to: `${adminRoot}/subscription/license-list`,
            iconClass: 'icon-custom-purple'
          },
          {
            icon: 'iconsminds-the-white-house',
            label: 'Courier Cities Mapping',
            to: `${adminRoot}/Setup/cities-mapping`,
            iconClass: 'icon-custom-purple'
          },
        ],
      },
    ],
  }
];
export default data;
